import logo from './logo.svg';
import './App.css';
import PexelsGallery from './PexelsGallery';

function App() {
  return (
    <div>
<PexelsGallery/>

    </div>
  );
}

export default App;
